import i from"@emotion/styled";import{setFontSizeList as o,setColor as e,setFontWeight as s}from"../../utils/generateStyles.js";const l=i.div`
  label: list;
  list-style-position: inside;
  margin: 0px;
  padding-right: 0;
  list-style-type: ${t=>t.listStyleType};
  ${t=>t.withPadding?{paddingRight:"24px"}:{paddingRight:0}};
  ${t=>o(t.fontSize)}
  ${t=>e(t.color,"color")}
  ${t=>s(t.fontWeight)}
`;export{l as ListStyled};
